import React from 'react'

import { useTranslation } from '../../contexts/I18nContext'
import { THEME } from '../../styles'

import Styled from './RecipeCharacteristicIndicators.styled'

const getTimeString = (time, t) => {
  const hours = Math.floor(time / 60)
  const minutes = time % 60
  let i18nKey = 'HOUR_MINUTE'

  if (hours && !minutes) {
    i18nKey = `HOUR${hours > 1 ? '_PLURAL' : ''}`
  } else if (minutes && !hours) {
    i18nKey = `MINUTE${minutes > 1 ? '_PLURAL' : ''}`
  }

  return t(`RECIPE.DISPLAY_TIME_${i18nKey}`, { hours, minutes })
}

const RecipeCharacteristicIndicators = ({
  backgroundColor,
  calories,
  className,
  cookingTime,
  isLoading,
  preparationTime,
  restingTime,
  textColor,
}) => {
  const { t } = useTranslation()

  return (
    <Styled className={className} backgroundColor={backgroundColor}>
      <Styled.characteristic>
        <Styled.characteristicContainer textColor={textColor}>
          <Styled.characteristicIcon
            name="preparation-24"
            width={32}
            height={32}
            fill={textColor}
          />
          {preparationTime || isLoading ? (
            <div>
              {isLoading ? (
                <Styled.textSkeleton animation="wave" />
              ) : (
                <p>{getTimeString(preparationTime, t)}</p>
              )}
              <p>{t('RECIPE.PREPARATION_TIME')}</p>
            </div>
          ) : (
            <div>
              {t('RECIPE.NOT')}
              <br /> {t('RECIPE.PREPARATION_TIME')}
            </div>
          )}
        </Styled.characteristicContainer>
      </Styled.characteristic>
      {cookingTime ? (
        <Styled.characteristic>
          <Styled.characteristicContainer textColor={textColor}>
            <Styled.characteristicIcon
              name="plate-stroke-24"
              width={32}
              height={32}
              fill={textColor}
            />
            {cookingTime || isLoading ? (
              <div>
                {isLoading ? (
                  <Styled.textSkeleton animation="wave" />
                ) : (
                  <p>{getTimeString(cookingTime, t)}</p>
                )}
                <p>{t('RECIPE.COOK_TIME')}</p>
              </div>
            ) : (
              <div>
                {t('RECIPE.NOT')}
                <br /> {t('RECIPE.COOK_TIME')}
              </div>
            )}
          </Styled.characteristicContainer>
        </Styled.characteristic>
      ) : null}
      {restingTime ? (
        <Styled.characteristic>
          <Styled.characteristicContainer textColor={textColor}>
            <Styled.characteristicIcon
              name="zzz-24"
              width={32}
              height={32}
              fill={textColor}
            />
            {restingTime || isLoading ? (
              <div>
                {isLoading ? (
                  <Styled.textSkeleton animation="wave" />
                ) : (
                  <p>{getTimeString(restingTime, t)}</p>
                )}
                <p>{t('RECIPE.RESTING_TIME')}</p>
              </div>
            ) : (
              <div>
                {t('RECIPE.NOT')}
                <br /> {t('RECIPE.RESTING_TIME')}
              </div>
            )}
          </Styled.characteristicContainer>
        </Styled.characteristic>
      ) : null}
      {calories?.amount && calories?.unit ? (
        <Styled.characteristic
          tabIndex={-1}
          tagName="a"
          href="#nutritional-facts"
        >
          <Styled.characteristicContainer textColor={textColor}>
            <Styled.characteristicIcon
              name="calorie-24"
              width={32}
              height={32}
              fill={textColor}
            />
            <div>
              <p>{`${calories.amount} ${calories.unit}`}</p>
              <p>{t('RECIPE.PER_SERVING')}</p>
            </div>
          </Styled.characteristicContainer>
        </Styled.characteristic>
      ) : null}
    </Styled>
  )
}

RecipeCharacteristicIndicators.defaultProps = {
  backgroundColor: THEME.COLORS.background.secondary,
  textColor: THEME.COLORS.foreground.primary,
}

export default RecipeCharacteristicIndicators
